'use client';

import { Step, StepIconProps, StepLabel, Stepper } from '@mui/material';
import { BoxComponent } from '../box/Box';
import styled from '@emotion/styled';
import DoneIcon from '@mui/icons-material/Done';

interface BaseHorizontalStepperProps {
  steps: string[];
  activeStep: number;
}

export function BaseHorizontalStepper({ steps, activeStep, ...otherProps }: BaseHorizontalStepperProps) {
  return (
    <BoxComponent sx={{ width: '100%' }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          '.MuiStepConnector-line': {
            border: '1px solid #53575D',
          },
          '.MuiStepLabel-label': {
            fontSize: '16px',
          },
        }}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={StepComponentIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </BoxComponent>
  );
}

export function StepComponentIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? <DoneIcon sx={{ height: '15px' }} /> : null}
    </ColorlibStepIconRoot>
  );
}

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  border: ownerState.completed ? '2px solid #5F68BC' : '2px solid #888d95',
  zIndex: 1,
  color: '#fff',
  width: 22,
  height: 22,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    border: '7px solid #5F68BC',
  }),
  backgroundColor: ownerState.completed ? '#5F68BC' : undefined,
}));
